import {themeConfig} from 'constants/theme';

export const isMobile = () => window?.innerWidth < themeConfig.screens.md;

const isLandscape = () => window?.innerWidth > window?.innerHeight;
const isLessSm = () => window?.innerWidth < themeConfig.screens.sm;
const isLessLg = () => window?.innerWidth < themeConfig.screens.lg;

export const screenUtils = {
    isLessSm,
    isLessLg,
    isMobile,
    isLandscape
};